const linkSocial = {
  en: {
    translation: {
      social_links_title: "Social links",
      keywords: "Search keywords"
    }
  },
  it: {
    translation: {
      social_links_title: "Social link attività",
      keywords: "Parole chiave di ricerca"
    }
  }
};

export default linkSocial;
